import { Component, Input } from '@angular/core';
import { trackByRef } from 'src/app/lego-utils';
import { ItemLog } from 'src/app/models/domain';

@Component({
  selector: 'em-item-logs-table',
  templateUrl: './item-logs-table.component.html',
  standalone: false,
})
export class ItemLogsTableComponent {
  @Input() public data: ItemLog[] = [];
  @Input() public errorMsg: string | undefined;
  @Input() public loading = false;

  public readonly trackByRef = trackByRef;
}
